function Videos() {
  return (
    <div>
      <div className="media">
        <iframe
          width="720"
          height="405"
          src="https://www.youtube.com/embed/ewTZzMy1QPk?si=Yg3z8QwL9a69koSz"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
        <iframe
          width="720"
          height="405"
          src="https://www.youtube.com/embed/0B0hPvBTnpw?si=NTl-QpEWqFwFwKZM"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
        <iframe
          width="720"
          height="405"
          src="https://www.youtube.com/embed/C7stBPNoblU?si=0quGGI1dw4iaAku0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        ></iframe>
      </div>
    </div>
  );
}

export default Videos;
